// import autoComplete from "@tarekraafat/autocomplete.js/dist/js/autoComplete.js";
import 'awesomplete/awesomplete'
import { apiUrl, getByAxios } from "../helpers/axios.js"

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {

    if (this.inputTargets.length > 0) {
      this.inputTargets.forEach((el) => {
        this.inputmount(el)
        document.addEventListener('turbolinks:before-cache', () => {
          this.inputunmount(el)
        }, {once: true})
      })
    }
  }

  // disconnect() {
  //   this.selectTargets.forEach((el) => {
  //     this.select2unmount($(el))
  //   })
  // }

  inputunmount(theInput) {

  }

  inputmount(theInput) {
    const endpoint  = theInput.getAttribute('data-endpoint')
    const related = theInput.getAttribute('data-related')
    const placeholder = theInput.getAttribute('data-placeholder')
    const onChooseEvent = theInput.getAttribute('data-onchoose')
    const getValue = theInput.getAttribute('data-getvalue')
    let queryParams = theInput.getAttribute('data-queryparams')

    let url = `${apiUrl}/${endpoint}`

    if (queryParams) {
      url = `${url}?${queryParams}`
    }

    let options = {
      minChars: 1,
      maxItems: 5,
      data: function (item, input) {
      	return { label: item[getValue], value: item }
      },
      replace: function (text) {
      	this.input.value = text.label
      }
    }

    var aInput = new Awesomplete(theInput, options)
    if (onChooseEvent) {
      theInput.addEventListener('awesomplete-selectcomplete', function (e) {
        eval(onChooseEvent)($(theInput), e.text.value)
      })
    }

    theInput.oninput = function(e) {
        const params = {
          term: theInput.value,
          related_id: $(related).val()
        }

        let data = getByAxios(require('axios'), url, { params: params })
        .then(function (response) {
          aInput.list = response.data
          aInput.evaluate()
        })
    }
  }
}

function TournamentsStages_OnChoose(theInput, data) {
  if (theInput.attr('id') != 'gt_tournaments_stage_name') {
    const el = $('#gt_tournaments_stage_name')
    if (el.val() == "") { el.val(data.text) }
  }
  if (theInput.attr('id') != 'gt_tournaments_stage_title') {
    const el = $('#gt_tournaments_stage_title')
    if (el.val() == "") { el.val(data.title) }
  }
  if (theInput.attr('id') != 'gt_tournaments_stage_eng') {
    const el = $('#gt_tournaments_stage_eng')
    if (el.val() == "") { el.val(data.eng) }
  }
}
